import { createFileRoute } from '@tanstack/react-router';
import StubPage from '@/pages/StubPage.jsx';

function ReportsRoute() {
  return <StubPage name="reports" />;
}

export const Route = createFileRoute('/reports')({ component: ReportsRoute });
